angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/tabindex/tabindex.js
// module id = 442
// module chunks = 0